"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledInputAdornment = exports.StyledFormControlLabel = exports.StyledSearchInput = exports.StyledProductTreeNodeSearch = void 0;
const material_1 = require("@mui/material");
const styled_components_1 = __importDefault(require("styled-components"));
exports.StyledProductTreeNodeSearch = styled_components_1.default.div `
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing(2)};
  overflow: hidden;

  .product-tree-node-search-content {
    display: flex;
    flex-direction: column;
    gap: ${({ theme }) => theme.spacing(2)};
    overflow-y: auto;
  }

  .load-more-indicator {
    padding: ${({ theme }) => theme.spacing(1)};
  }
`;
// TODO: create a separate component
exports.StyledSearchInput = (0, styled_components_1.default)(material_1.OutlinedInput) `
  && {
    height: 48px;
    min-width: 260px;
    flex-basis: fill;
    border-radius: 4px;
    flex: 1;

    &:hover .MuiOutlinedInput-notchedOutline,
    &.Mui-focused .MuiOutlinedInput-notchedOutline,
    .MuiOutlinedInput-notchedOutline {
      border-color: ${({ theme }) => theme.palette.grey[200]};
      border-width: 1px;
    }
  }
`;
exports.StyledFormControlLabel = (0, styled_components_1.default)(material_1.FormControlLabel) `
  margin-left: 0;
  margin-right: 0;
`;
exports.StyledInputAdornment = (0, styled_components_1.default)(material_1.InputAdornment) `
  gap: ${({ theme }) => theme.spacing(1)};
`;
